import {ProductImageCarousel} from './modules/WoocommerceProductPage';
import {AjaxCart} from "./modules/AjaxCart";
import AddToCartEvent from "./modules/AddToCartEvent";
import {ProductSwatches} from "./modules/Swatches";
import WoocommerceQuantity from "./modules/WoocommerceQuantity";
WoocommerceQuantity();
ProductImageCarousel();
ProductSwatches();
AddToCartEvent();
AjaxCart();

setTimeout(function () {
    const galleryTrigger = $('.woocommerce-product-gallery__trigger');

    galleryTrigger.html(`
        <div class="flex items-center">
        <div class="woocommerce-product-gallery__trigger--inner">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
            </svg>
        </div>
        
            <span class="woocommerce-product-gallery__trigger--text font-extrabold text-sm">Noklikšķiniet, lai palielinātu</span>
        </div>
    `

    );

}, 200);


